"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValueUnhandledNull = exports.formatMetric = exports.HYPHEN = void 0;
var tslib_1 = require("tslib");
var numberjs_1 = require("@gooddata/numberjs");
var isNull_1 = tslib_1.__importDefault(require("lodash/isNull"));
exports.HYPHEN = "–"; // EN DASH (not usual 'minus')
function formatMetric(number, format, separators) {
    if (format === void 0) { format = "#,##0.00"; }
    return numberjs_1.numberFormat(isNull_1.default(number) ? "" : number, numberjs_1.stripColors(format), undefined, separators);
}
exports.formatMetric = formatMetric;
function isValueUnhandledNull(value, format) {
    return isNull_1.default(value) && !numberjs_1.containsNullConditionalFormat(format);
}
exports.isValueUnhandledNull = isValueUnhandledNull;
//# sourceMappingURL=format.js.map